(ns dre.pages.frontpage.db)

(def init-db
  {:search-type :topic-search})

